import api from './axiosConfig';
import { COUNTRY, COUNTRY_ZHO, COUNTRY_REGION_ENDPOINT } from './apiEndpoints';
import { logError } from './errorLogService';
// import countryMockData from '../data/countries.json'

export const fetchCountry = async (lang = 'eng') => {
    try {

        const response = await api.get(lang == 'eng' ? COUNTRY() : COUNTRY_ZHO());

        // Filtrar los datos para excluir el país con id = 1
        // const filteredData = response.data.filter(item => item.id !== 1);

        return response.data;
    } catch (error) {
        console.error("Error fetching country data", error);

        await logError('country_data_fetch', error, {
            endpoint: lang === 'eng' ? COUNTRY() : COUNTRY_ZHO(),
            lang,
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        throw error;
    }
};

export const fetchRegionsByCountryId = async (countryId) => {
    try {
        const response = await api.get(COUNTRY_REGION_ENDPOINT(countryId));
        return response.data;
    } catch (error) {
        console.error("Error fetching regions by country ID", error);

        await logError('country_regions_fetch', error, {
            endpoint: COUNTRY_REGION_ENDPOINT(countryId),
            countryId,
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        throw error;
    }
};
